import { Section } from "../tools/section";
import { responsiveMediaAbove } from "../settings/responsive";
import { Swiper } from "swiper";
import { Scrollbar, Navigation } from "swiper/modules";

// To use gsap, ensure it is installed in your project:
// Run: npm install gsap
// Then import it as shown above.

// Selectors
export const SELECTOR_SECTION   = '[data-image-and-text]';
const SELECTOR_SWIPER_CONTAINER = '[data-swiper-container]';
const SELECTOR_SWIPER_SCROLLBAR = '[data-swiper-scrollbar]';

const SELECTOR_CHARITY_DRAWER_OPEN = '[data-charity-drawer-btn]';

export class ImageAndText extends Section {
  private swiperInstances: Map<string, Swiper> = new Map();
  private swiperContainer: HTMLElement | null = null;
  private scrollbarEl: HTMLElement | null = null;
  private charityDrawerBtn: NodeListOf<HTMLElement> | null = null;

  queryChildren(container: HTMLElement) {
    this.swiperContainer = container.querySelector(SELECTOR_SWIPER_CONTAINER);
    this.scrollbarEl = container.querySelector(SELECTOR_SWIPER_SCROLLBAR);
    this.charityDrawerBtn = container.querySelectorAll(SELECTOR_CHARITY_DRAWER_OPEN);
  }

  attachEvents() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (this.charityDrawerBtn) {
      this.charityDrawerBtn.forEach(btn => {
        btn.addEventListener('click', this.toggleCharityDrawer);
      });
    }
  }

  detatchEvents(): void {
    window.removeEventListener('resize', this.handleResize);
    if (this.charityDrawerBtn) {
      this.charityDrawerBtn.forEach(btn => {
        btn.removeEventListener('click', this.toggleCharityDrawer);
      });
    }
  }

  handleResize = () => {
    if (!this.swiperContainer) return;
    const key = this.swiperContainer.getAttribute('data-swiper-container')!;
    if (!responsiveMediaAbove('medium')) {
      if (!this.swiperInstances.has(key)) {
        this.initializeSwiper(this.swiperContainer);
      }
    } else {
      if (this.swiperInstances.has(key)) {
        const swiper = this.swiperInstances.get(key)!;
        swiper.destroy(true, true);
        this.swiperInstances.delete(key);
      }
    }
  };

  initializeSwiper(container: HTMLElement) {
    const swiper = new Swiper(container, {
      modules: [Scrollbar, Navigation],
      slidesPerView: 1,
      loop: false,
      keyboard: true,
      grabCursor: true,
      scrollbar: {
        el: this.scrollbarEl,
        draggable: true,
      }
    });
    this.swiperInstances.set(container.getAttribute('data-swiper-container')!, swiper);
  }

  toggleCharityDrawer() {
    // Trigger the data-tab-target="charities" drawer button
    const drawerBtn = document.querySelector<HTMLElement>('[data-tab-target="charities"]');
    if (drawerBtn) {
      drawerBtn.click();
    } else {
      console.warn('Charity drawer button not found');
    }
  }

}

Section.register(SELECTOR_SECTION, ImageAndText);